module.exports = __webpack_public_path__ + "media/images/workplace/login-maskott-c9276059d74d50fe9b6d57fb90489c94.jpg";